<div class="sidebar-header" [class.collapsed]="!isExpanded">
    <div class="logo-container" (click)="!isExpanded ? toggleSidebar() : undefined"></div>

    <ng-container *ngIf="isExpanded">
        <div class="logo-label">Talonic</div>
        <div class="minimize-sidebar" (click)="toggleSidebar()"></div>
    </ng-container>
</div>
